// extracted by mini-css-extract-plugin
module.exports = {"container":"Empty_container__3Oejd"};